/** Default clinic glyph when CMS omits `icon.permalink` (e.g. `ServiceTypeBlock`). */
export const FALLBACK_CLINIC_ICON = "/icons/clinic-icon-green.svg";
